import BrowserStorage from '@/util/localStorage/BrowserStorage';

export enum ThemeOpts {
  light = 'light',
  dark = 'dark',
}

const getDefaultTheme = () => {
  const isOSDark = (
    window.matchMedia
    && window.matchMedia('(prefers-color-scheme: dark)').matches
  );
  return isOSDark ? ThemeOpts.dark : ThemeOpts.light;
};

const storage = new BrowserStorage('theme', getDefaultTheme(), 'config-');
export const getTheme = () => storage.get();
export const setTheme = (theme: ThemeOpts) => {
  document.documentElement.className = theme;
  storage.set(theme);
  const styleId = 'harmon-dark-light-theme';
  const selector = document.querySelector(`style#${styleId}`);
  const innerHTML = `
    :root {
      color-scheme: ${theme};
      supported-color-schemes: light dark;
    }
  `;
  if (!selector) {
    const style = document.createElement('style');
    style.setAttribute('id', styleId);
    style.innerHTML = innerHTML;
    document.head.appendChild(style);
  } else {
    selector.innerHTML = innerHTML;
  }
};
